import { useSearchParams } from 'react-router-dom';

import { useBoundStore } from 'app/store';
/**
 *
 * @param {string} key
 */
export const useSaveServiceParams = (key, savedServiceParams = {}) => {
  const [searchParams] = useSearchParams();
  const addServiceParams = useBoundStore((store) => store[key].addServiceParams);

  let allParams = savedServiceParams;

  if (Object.keys(allParams).length < 1) {
    for (const [k, v] of searchParams.entries()) {
      allParams = { ...allParams, [k]: v };
    }
    addServiceParams(allParams);
  }

  return allParams;
};
